import { Dialog, DialogContent, DialogHeader, DialogTrigger } from '@/components/ui/dialog';
import Table from '../Table';
import { fetchMastered } from '@/lib/fetchMastered';
import useSWR from 'swr';
import { MAX_MASTERY_COUNT } from '@/constants';
import Loading from '@/components/ui/Loading';

export default function SharedDialog({ studentId, token, pathName, label }: { studentId: number; token: string; pathName: string; label: string }) {
  const { data, error, isLoading } = useSWR([`/wp-json/quiz-leaderboard/v1/${pathName}/${studentId}`, token], ([path, token]) => fetchMastered(path, token), { revalidateOnFocus: false });
  if (error) {
    <>Error occured</>;
  }
  if (isLoading) {
    <>Loading...</>;
  }
  return (
    <Dialog>
      {isLoading ? (
        <div className='flex mx-auto justify-center w-full items-center mt-3'>
          <Loading />
        </div>
      ) : (
        <DialogTrigger className='w-full py-2 px-5 bg-[#35D461] text-white rounded-md mt-3'>{label}</DialogTrigger>
      )}
      <DialogContent className='dialog-box max-w-5xl w-full p-4 border-none [&_button]:-top-4 [&_button]:-right-4 [&_button>svg]:h-5 [&_button>svg]:w-5 [&_button]:bg-white [&_button]:rounded-full [&_button]:shadow-md [&_button]:w-8 [&_button]:h-8 [&_button]:flex [&_button]:justify-center [&_button]:items-center '>
        <DialogHeader>
          <div className='w-full rounded-sm'>
            <Table MAX_MASTERY_COUNT={pathName == 'mastered-topics' ? MAX_MASTERY_COUNT : 0} results={data?.data || []} />
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
